import { Component, Input, OnInit } from '@angular/core';
import { ChispazoTicket } from '@app/@shared/models/chispazo.model';
import { GameTicket, GameType } from '@app/@shared/models/game.model';
import { GanaGatoTicket } from '@app/@shared/models/gana-gato.model';
import { MelateTicket } from '@app/@shared/models/melate.model';
import { SorteoTicket, SorteoType } from '@app/@shared/models/sorteo.model';
import { TrisTicket } from '@app/@shared/models/tris.model';
import { ChispazoService } from '@app/@shared/services/chispazo.service';
import { GanaGatoService } from '@app/@shared/services/gana-gato.service';
import { MelateService } from '@app/@shared/services/melate.service';
import { SorteoService } from '@app/@shared/services/sorteo.service';
import { TrisService } from '@app/@shared/services/tris.service';
import { ModalController } from '@ionic/angular';
import { GameLogoService } from '@app/@shared/services/game-logo.service';

@Component({
  selector: 'app-favorite',
  templateUrl: './favorite.component.html',
  styleUrl: './favorite.component.scss',
})
export class FavoriteComponent implements OnInit {
  @Input() option = 'favorite';
  @Input() isModal = true;
  @Input() tickets: GameTicket[] = [];
  @Input() gameType!: GameType;

  @Input() quantity = 0;
  sorteoTickets: SorteoTicket[] = [];
  @Input() sorteoType?: SorteoType;
  @Input() sorteoS?: SorteoService;

  @Input() isRetro = false;
  @Input() melateS?: MelateService;
  melateTickets: MelateTicket[] = [];

  @Input() chispazoS?: ChispazoService;
  chispazoTickets: ChispazoTicket[] = [];

  @Input() trisS?: TrisService;
  trisTickets: TrisTicket[] = [];

  @Input() ganaGatoS?: GanaGatoService;
  ganaGatoTickets: GanaGatoTicket[] = [];

  selected: boolean[] = [];
  letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  logoMelate = '/assets/logos/melate-revancha-revanchita.svg';
  logoMelateRetro = '/assets/logos/melate-retro.svg';
  logoChispazo = '/assets/logos/chispazo.svg';
  logoTris = '/assets/logos/tris.svg';
  logoGanaGato = '/assets/logos/gana-gato.svg';

  constructor(private modalCtrl: ModalController, private gameLogoS: GameLogoService) {}

  ngOnInit(): void {
    this.selected = [];
    this.loadLogos();

    // Inicializa todos los arrays de selección en `false`
    const initializeSelection = (tickets: any[]) => new Array(tickets.length).fill(false);
    if (this.option === 'favorite') {
      if (this.melateS) {
        this.melateTickets = this.melateS.getFavoriteTickets();
        this.selected = initializeSelection(this.melateTickets);
        if (this.melateTickets.length > 0) this.selected[0] = true;
      } else if (this.sorteoS && this.sorteoType) {
        const path = this.sorteoS.getPaths().find((p) => p.path === this.sorteoType)!;

        this.sorteoS.getFavorites(path).then((ts: any[]) => {
          this.sorteoTickets = ts; // completos con icon, idSigno, etc.
          this.selected = this.sorteoTickets.map(() => true);
        });
      } else if (this.chispazoS) {
        this.chispazoTickets = this.chispazoS.getFavoriteTickets();
        this.selected = initializeSelection(this.chispazoTickets);
        if (this.chispazoTickets.length > 0) this.selected[0] = true;
      } else if (this.trisS) {
        this.trisTickets = this.trisS.getFavoriteTickets();
        this.selected = initializeSelection(this.trisTickets);
        if (this.trisTickets.length > 0) this.selected[0] = true;
      } else if (this.ganaGatoS) {
        this.ganaGatoTickets = this.ganaGatoS.getFavoriteTickets();
        this.selected = initializeSelection(this.ganaGatoTickets);
        if (this.ganaGatoTickets.length > 0) this.selected[0] = true;
      }
    } else if (this.option === 'purchase') {
      if (this.gameType === 'melate') {
        this.melateTickets = this.tickets as MelateTicket[];
        this.melateTickets.forEach((v) => {
          this.selected.push(true);
        });
      } else if (this.gameType === 'sorteo') {
        // const path = this.sorteoS.getPaths().find((p) => p.path === this.sorteoType)!;
        // this.sorteoTickets = this.sorteoS.getFavorites(path);
        // this.sorteoTickets.forEach((v) => {
        //   this.selected.push(true);
        // });
      } else if (this.gameType === 'chispazo') {
        this.chispazoTickets = this.tickets as ChispazoTicket[];
        // this.chispazoTickets.forEach((v) => {
        //   this.selected.push(true);
        // });
      } else if (this.trisS) {
        this.trisS.getFavorite().then((ts) => {
          this.trisTickets = ts;
          this.trisTickets.forEach((v) => {
            this.selected.push(true);
          });
        });
      } else if (this.ganaGatoS) {
        this.ganaGatoTickets = this.ganaGatoS.getFavorite();
        this.ganaGatoTickets.forEach((v) => {
          this.selected.push(true);
        });
      }
    }
  }

  private async loadLogos(): Promise<void> {
    await this.gameLogoS.ensureLoaded();
    this.logoMelate = this.gameLogoS.getLogo('Melate', this.logoMelate);
    this.logoMelateRetro = this.gameLogoS.getLogo('MelateRetro', this.logoMelateRetro);
    this.logoChispazo = this.gameLogoS.getLogo('Chispazo', this.logoChispazo);
    this.logoTris = this.gameLogoS.getLogo('Tris', this.logoTris);
    this.logoGanaGato = this.gameLogoS.getLogo('GanaGato', this.logoGanaGato);
  }

  get melateLogo(): string {
    return this.isRetro ? this.logoMelateRetro : this.logoMelate;
  }

  close() {
    this.modalCtrl.dismiss();
  }

  // deleteValue(i: number) {}

  goTo() {}

  reload(i: number) {}

  changeSelected(i: number) {
    this.selected.fill(false);
    this.selected[i] = true;
  }

  applySelected() {
    let selectedTickets: GameTicket[] = [];
    if (this.melateTickets.length > 0) {
      this.melateTickets.forEach((ticket, i) => {
        if (this.selected[i]) {
          selectedTickets.push(ticket);
        }
      });
    } else if (this.sorteoTickets.length > 0) {
      this.sorteoTickets.forEach((ticket, i) => {
        if (this.selected[i]) {
          selectedTickets.push(ticket);
        }
      });
    } else if (this.chispazoTickets.length > 0) {
      this.chispazoTickets.forEach((ticket, i) => {
        if (this.selected[i]) {
          selectedTickets.push(ticket);
        }
      });
    } else if (this.trisTickets.length > 0) {
      this.trisTickets.forEach((ticket, i) => {
        if (this.selected[i]) {
          selectedTickets.push(ticket);
        }
      });
    } else if (this.ganaGatoTickets.length > 0) {
      this.ganaGatoTickets.forEach((ticket, i) => {
        if (this.selected[i]) {
          selectedTickets.push(ticket);
        }
      });
    }
    this.modalCtrl.dismiss({ selectedTickets });
  }

  changeQuantity(n: number) {}

  getZodiacName(icon: string) {
    const zodiacs = this.sorteoS?.zodiac.find((z) => z.icon === icon);

    return zodiacs?.name ?? '';
  }

  deleteValue(i: number) {
    if (this.option === 'favorite') {
      if (this.melateS) {
        const ticketToDelete = this.melateTickets[i];
        this.melateS.deleteFavorite(ticketToDelete);
        this.melateTickets = this.melateS.getFavoriteTickets();
        this.selected.splice(i, 1);
      } else if (this.chispazoS) {
        const ticketToDelete = this.chispazoTickets[i];
        this.chispazoS.deleteFavorite(ticketToDelete);
        this.chispazoTickets = this.chispazoS.getFavoriteTickets();
        this.selected.splice(i, 1);
      } else if (this.trisS) {
        if (this.trisS) {
          const ticketToDelete = this.trisTickets[i];
          this.trisS.deleteFavorite(ticketToDelete);
          this.trisTickets = this.trisS.getFavoriteTickets();
          this.selected.splice(i, 1);
        }
      } else if (this.ganaGatoS) {
        if (this.ganaGatoS) {
          const ticketToDelete = this.ganaGatoTickets[i];
          this.ganaGatoS.deleteFavorite(ticketToDelete);
          this.ganaGatoTickets = this.ganaGatoS.getFavoriteTickets();
          this.selected.splice(i, 1);
        }
      } else if (this.sorteoS && this.sorteoType) {
        const type = this.sorteoType as SorteoType;
        const ticketToDelete = this.sorteoTickets[i].value;

        this.sorteoS?.deleteFavorite(ticketToDelete, this.sorteoType);
        this.sorteoS?.getFavorites(type).then((favorites: number[][]) => {
          this.sorteoTickets = favorites.map((ticketNumbers) => ({
            name: type,
            value: ticketNumbers,
            available: 0,
            added: 0,
            icon: '',
            dates: [],
            amount: 0,
            price: 0,
            idSigno: 0,
          }));
        });

        this.selected.splice(i, 1);
      }

      this.selected.splice(i, 1);
    }
  }
  getZodiacIcon(signName: string): string {
    const icons: { [key: string]: string } = {
      aries: 'assets/icons/zodiac/game-icons_aries.svg',
      taurus: 'assets/icons/zodiac/game-icons_taurus.svg',
      gemini: 'assets/icons/zodiac/game-icons_gemini.svg',
      cancer: 'assets/icons/zodiac/game-icons_cancer.svg',
      leo: 'assets/icons/zodiac/game-icons_leo.svg',
      virgo: 'assets/icons/zodiac/game-icons_virgo.svg',
      libra: 'assets/icons/zodiac/game-icons_libra.svg',
      scorpio: 'assets/icons/zodiac/game-icons_scorpio.svg',
      sagittarius: 'assets/icons/zodiac/game-icons_sagittarius.svg',
      capricorn: 'assets/icons/zodiac/game-icons_capricorn.svg',
      aquarius: 'assets/icons/zodiac/game-icons_aquarius.svg',
      pisces: 'assets/icons/zodiac/game-icons_pisces.svg',
    };

    return icons[signName.toLowerCase()] || 'assets/icons/zodiac/default.svg';
  }
}
